import React from "react";
import LogoLinkedin from "../../assets/logos/logo-linkedin.svg";
import { ReactComponent as LogoShort } from "../../assets/logos/logo-forager-white.svg";
import Rokect from "../../assets/img/footer/rocket.svg";
import RokectDesktop from "../../assets/img/footer/rocket-desktop.svg";
import NewsOne from "../../assets/img/footer/news-one.svg";
import NewsTwo from "../../assets/img/footer/news-two.svg";
import NewsThree from "../../assets/img/footer/news-three.svg";

function AppFooter() {
  const show = false;

  return (
    <footer>
      <div className="px-4 md:px-0 bg-dark-denim text-white">
        <div className="container grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-y-14 md:gap-x-16 md:mx-auto pt-16">
          <div className="md:col-span-2">
            <LogoShort className="w-32 h-14 mb-10 lg:mb-8" />
            <p className="mb-12 lg:mb-8 pr-14">
              Forager International is an investment management business
              developing innovative service solutions for partners around the
              world that engage with heritage. We build off the guiding forces
              of collaboration, community development, inclusivity, and
              sustainability.
            </p>
            <p className="bg-white w-8 h-0.5 mb-1 rounded-md"> </p>
            <div>
              <a href="follow" className="flex" target="_blank">
                follow us
                <img
                  src={LogoLinkedin}
                  alt="linkedin logo"
                  className="ml-2 w-7 h-7"
                />
              </a>
            </div>
          </div>

          <div className="mr-11 lg:mr-0">
            <p className="bg-white w-8 h-0.5 rounded-md"> </p>
            <h4 className="text-2xl font-medium">forager news</h4>
            {show ? (
              <>
                <div className="flex gap-4 mt-11 lg:mt-4">
                  <img src={NewsOne} alt="forager news" />
                  <p>Lorem ipsum dolor sit amet consectetur.</p>
                </div>
                <div className="flex gap-6 mt-7 lg:mt-6">
                  <img src={NewsTwo} alt="forager news" />
                  <p>Lorem ipsum dolor sit amet consectetur.</p>
                </div>
                <div className="flex gap-6 mt-7 lg:mt-6">
                  <img src={NewsThree} alt="forager news" />
                  <p>Lorem ipsum dolor sit amet consectetur.</p>
                </div>
              </>
            ) : (
              <p className="mt-5 text-white">Important news coming soon!</p>
            )}
          </div>
          <div className="flex gap-y-4 flex-col">
            <div className="mb-5 lg:mb-0">
              <p className="bg-white w-8 h-0.5 rounded-md"> </p>
              <h4 className="text-2xl font-medium">contact us</h4>
            </div>
            <p>
              <span className="font-medium"> headquarters: </span>
              Cork, Ireland
            </p>
            <p>
              <span className="font-medium">phone: </span>
              +1 250 569 4401
            </p>
            <p>
              <span className="font-medium block">general enquiries:</span>
              info@foragerinternational.com
            </p>
            <p>
              <span className="font-medium block">partnership enquiries:</span>
              partners@foragerinternational.com
            </p>
            <p className="pb-5">
              <span className="font-medium block">investor enquiries:</span>
              invest@foragerinternational.com
            </p>
          </div>
        </div>
        <div className="pb-2 text-center mt-16">
          <hr className="lg:w-32 lg:mx-auto" />
          <span className="text-[0.5rem] md:text-xs">
            © Copyright 2023, Forager Group Holdings Ltd. All rights reserved.
          </span>
        </div>
      </div>
      <div className="container mx-auto relative">
        <img
          src={Rokect}
          alt=""
          className="absolute bottom-10 w-24 lg:w-28 right-0 md:hidden"
        />
        <img
          src={RokectDesktop}
          alt=""
          className="absolute bottom-2 right-[13%] hidden xl:block"
        />
      </div>
    </footer>
  );
}

export default AppFooter;
